// extracted by mini-css-extract-plugin
export default {"form":"EditarContrato_form__-5Gaa","areaBtn":"EditarContrato_areaBtn__X8O4S","btn":"EditarContrato_btn__Vq8PR","btn2":"EditarContrato_btn2__K5hQG"};